import React from 'react';
import styled from 'styled-components';

export default styled.a`
  &.open svg {
    transform: rotate(90deg);
  }
`;
